// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"b70c3c2b","453":"18cd48a0","455":"69092dd1","644":"958ae009"}[chunkId] + ".chunk.js";
};